import { Http } from '../../../support';
import { Guardian } from '@xaamin/guardian';

const initialState = {
  busy: false,
  isValid: false,
  fetching: false,
  data: {},
  steps: [],
  error: undefined,
  result: undefined,
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.admin.clientes.upsert = {
      ...state.admin.clientes.upsert,
      ...data,
    };
  });
};

const upsert = async (store, data, id) => {
  store.setState((state) => {
    state.admin.clientes.upsert.busy = true;
  });

  try {
    let response;
    let headers = {
      ...data,
    };

    if (!Guardian.allows('cliente.editar.servicios')) {
      headers = {
        ...data,
        servicios: undefined,
      };
    }

    if (!id) {
      response = await Http.post(`api/clientes`, headers);
    } else {
      response = await Http.put(`api/clientes/${id}`, headers);
    }

    store.setState((state) => {
      state.admin.clientes.upsert = {
        ...state.admin.clientes.upsert,
        result: response,
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.admin.clientes.upsert.error = error.data || error;
    });
  } finally {
    store.setState((state) => {
      state.admin.clientes.upsert.busy = false;
    });
  }
};

const _getNewStepsAfterVerification = (all, step, valid) => {
  return all.map((item) => {
    const assignable = { ...item };

    if (step.number === assignable.number) {
      assignable.done = valid;
    }

    return assignable;
  });
};

const _isValid = (steps) => {
  return steps.every((value) => !!value.done);
};

const setStepDataChange = (store, event) => {
  const { upsert } = store.state.admin.clientes;

  const steps = _getNewStepsAfterVerification(upsert.steps, event.step, event.isValid);

  const isValid = _isValid(steps);

  store.setState((state) => {
    state.admin.clientes.upsert = {
      ...state.admin.clientes.upsert,
      data: {
        ...state.admin.clientes.upsert.data,
        ...event.data,
      },
      steps,
      isValid,
    };
  });
};

const reset = (store) => {
  store.setState((state) => {
    state.admin.clientes.upsert = { ...initialState };
  });
};

const ClienteUpsertStore = {
  state: () => initialState,
  actions: {
    reset,
    upsert,
    setPartialState,
    setStepDataChange,
  },
};

export default ClienteUpsertStore;
